<template>
  <BackLastPage title="添加收货地址" />
  <div>
    <van-form label-width="100" @submit="saveAddress">
      <van-field v-model="recipient" name="recipient" label="姓名" placeholder="请填写名字" maxlength="20" required :rules="[{ required: true }]" />
      <van-field
        v-model="mobile"
        name="mobile"
        label="手机号码"
        placeholder="请填写手机号码"
        required
        :rules="[{ required: true }, { pattern: mobileValidator, message: '手机号码输入有误' }]"
      />
      <van-field
        v-model="cityInfo.text"
        name="cityInfo"
        label="所在地区"
        placeholder="请选择所在地区"
        readonly
        required
        :right-icon="'arrow'"
        :rules="[{ required: true }]"
        @click="selectCity"
      />
      <van-field
        v-model="address"
        type="textarea"
        rows="3"
        autosize
        name="address"
        label="详细地址"
        placeholder="请填写详细地址"
        maxlength="50"
        required
        :rules="[{ required: true }]"
      />
      <div class="defaultAddress">
        <span>设为默认地址</span>
        <van-switch class="switch" v-model="isDefault" size="24px" />
      </div>
      <van-button class="button" type="primary" size="large" native-type="submit">保存</van-button>
      <van-button v-if="id" class="button" size="large" @click="deleteAddress">删除</van-button>
    </van-form>
    <SelectCity :fromCompleteInfo="true" :showNum="showCity" :provinceCity="cityInfo.provinceCity" @getCity="getCity" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { Toast } from 'vant'
import { getProvinceIdAndCityId } from '@/util/city'
import { mobileValidator } from '@/util/regEx.js'
import { getAddressInfo, updateAddressInfo, addAddressInfo, deleteAddressInfo } from '@/api/profile'
import BackLastPage from '@/components/common/BackLastPage.vue'
import SelectCity from '@/components/common/SelectCity.vue'

export default {
  components: {
    BackLastPage,
    SelectCity
  },

  setup() {
    const store = useStore()
    const { profile } = store.state
    const route = useRoute()
    let { id } = route.query

    const state = reactive({
      showCity: 0,
      isDefault: false,
      id,
      recipient: '',
      mobile: '',
      cityInfo: {
        text: ''
      },
      address: ''
    })

    onMounted(async () => {
      if (!state.id) {
        // 自动填充当前用户的姓名与电话
        if (profile.username) state.recipient = profile.username
        if (profile.phone) state.mobile = profile.phone

        const { locationInfo } = store.state
        // 获取省份和城市Id
        const indexArr = await getProvinceIdAndCityId(locationInfo.province, locationInfo.city)

        state.cityInfo = indexArr.length
          ? {
              text: `${locationInfo.province}/${locationInfo.city}`,
              provinceCity: [locationInfo.province, locationInfo.city],
              indexArr: indexArr,
              cityName: locationInfo.city,
              provinceName: locationInfo.province
            }
          : { text: '' }

        return
      }

      // 获取已有地址信息
      const { address } = await getAddressInfo(state.id)
      state.isDefault = !!address.isDefault
      state.recipient = address.recipient
      state.mobile = address.mobile
      state.cityInfo = {
        text: `${address.provinceName}/${address.cityName}`,
        indexArr: [address.provinceId, address.cityId],
        provinceCity: [address.provinceName, address.cityName],
        cityId: address.cityId,
        cityName: address.cityName,
        provinceId: address.provinceId,
        provinceName: address.provinceName
      }
      state.address = address.address
    })

    const selectCity = () => (state.showCity += 1)

    const getCity = val => (state.cityInfo = val)

    const saveAddress = async () => {
      // 创建api所需参数
      const params = {
        id: state.id,
        isDefault: state.isDefault ? 1 : 0,
        recipient: state.recipient,
        mobile: state.mobile,
        cityId: state.cityInfo.indexArr[1],
        cityName: state.cityInfo.cityName,
        provinceId: state.cityInfo.indexArr[0],
        provinceName: state.cityInfo.provinceName,
        address: state.address
      }

      try {
        if (state.id) {
          await updateAddressInfo(params)
        } else {
          await addAddressInfo(params)
        }

        //保存地址成功，返回上一层页面（地址列表页面）
        history.back()
      } catch {
        Toast({ message: '保存地址失败' })
      }
    }

    const deleteAddress = async () => {
      try {
        deleteAddressInfo(state.id)

        //删除地址成功，返回上一层页面（地址列表页面）
        history.back()
      } catch {
        Toast({ message: '删除地址失败' })
      }
    }

    return {
      ...toRefs(state),
      mobileValidator,
      selectCity,
      getCity,
      saveAddress,
      deleteAddress
    }
  }
}
</script>

<style lang="scss" scoped>
.defaultAddress {
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  font-size: 13px;
  .switch {
    margin-left: 14px;
  }
}
.button {
  margin-top: 10px;
}
</style>
